/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
import {
  Signer,
  utils,
  Contract,
  ContractFactory,
  Overrides,
  BigNumberish,
} from "ethers";
import { Provider, TransactionRequest } from "@ethersproject/providers";
import type { SiloConvex, SiloConvexInterface } from "../SiloConvex";

const _abi = [
  {
    inputs: [
      {
        internalType: "contract ISiloRepository",
        name: "_repository",
        type: "address",
      },
      {
        internalType: "contract ISiloConvexStateChangesHandler",
        name: "_stateChangesHandler",
        type: "address",
      },
      {
        internalType: "address",
        name: "_siloAsset",
        type: "address",
      },
      {
        internalType: "uint128",
        name: "_version",
        type: "uint128",
      },
    ],
    stateMutability: "nonpayable",
    type: "constructor",
  },
  {
    inputs: [],
    name: "AssetDoesNotExist",
    type: "error",
  },
  {
    inputs: [],
    name: "BorrowNotPossible",
    type: "error",
  },
  {
    inputs: [],
    name: "DepositNotPossible",
    type: "error",
  },
  {
    inputs: [],
    name: "DepositsExceedLimit",
    type: "error",
  },
  {
    inputs: [],
    name: "DifferentArrayLength",
    type: "error",
  },
  {
    inputs: [],
    name: "InvalidRepository",
    type: "error",
  },
  {
    inputs: [],
    name: "InvalidSiloVersion",
    type: "error",
  },
  {
    inputs: [],
    name: "LiquidationReentrancyCall",
    type: "error",
  },
  {
    inputs: [],
    name: "MaximumLTVReached",
    type: "error",
  },
  {
    inputs: [],
    name: "NotEnoughDeposits",
    type: "error",
  },
  {
    inputs: [],
    name: "NotEnoughLiquidity",
    type: "error",
  },
  {
    inputs: [],
    name: "NotSolvent",
    type: "error",
  },
  {
    inputs: [],
    name: "OnlyRouter",
    type: "error",
  },
  {
    inputs: [],
    name: "Paused",
    type: "error",
  },
  {
    inputs: [],
    name: "TokenIsNotAContract",
    type: "error",
  },
  {
    inputs: [],
    name: "UnexpectedEmptyReturn",
    type: "error",
  },
  {
    inputs: [],
    name: "UnsupportedLTVType",
    type: "error",
  },
  {
    inputs: [],
    name: "UserIsZero",
    type: "error",
  },
  {
    inputs: [],
    name: "ZeroAssets",
    type: "error",
  },
  {
    inputs: [],
    name: "ZeroShares",
    type: "error",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "asset",
        type: "address",
      },
      {
        indexed: true,
        internalType: "enum IBaseSilo.AssetStatus",
        name: "status",
        type: "uint8",
      },
    ],
    name: "AssetStatusUpdate",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "asset",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "user",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
    ],
    name: "Borrow",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "asset",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "depositor",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "bool",
        name: "collateralOnly",
        type: "bool",
      },
    ],
    name: "Deposit",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "asset",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "user",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "shareAmountRepaid",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "seizedCollateral",
        type: "uint256",
      },
    ],
    name: "Liquidate",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "asset",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "user",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
    ],
    name: "Repay",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "asset",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "depositor",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "receiver",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "bool",
        name: "collateralOnly",
        type: "bool",
      },
    ],
    name: "Withdraw",
    type: "event",
  },
  {
    inputs: [],
    name: "VERSION",
    outputs: [
      {
        internalType: "uint128",
        name: "",
        type: "uint128",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_asset",
        type: "address",
      },
    ],
    name: "accrueInterest",
    outputs: [
      {
        internalType: "uint256",
        name: "interest",
        type: "uint256",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_asset",
        type: "address",
      },
    ],
    name: "assetStorage",
    outputs: [
      {
        components: [
          {
            internalType: "contract IShareToken",
            name: "collateralToken",
            type: "address",
          },
          {
            internalType: "contract IShareToken",
            name: "collateralOnlyToken",
            type: "address",
          },
          {
            internalType: "contract IShareToken",
            name: "debtToken",
            type: "address",
          },
          {
            internalType: "uint256",
            name: "totalDeposits",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "collateralOnlyDeposits",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "totalBorrowAmount",
            type: "uint256",
          },
        ],
        internalType: "struct IBaseSilo.AssetStorage",
        name: "",
        type: "tuple",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_asset",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "_amount",
        type: "uint256",
      },
    ],
    name: "borrow",
    outputs: [
      {
        internalType: "uint256",
        name: "debtAmount",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "debtShare",
        type: "uint256",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_asset",
        type: "address",
      },
      {
        internalType: "address",
        name: "_borrower",
        type: "address",
      },
      {
        internalType: "address",
        name: "_receiver",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "_amount",
        type: "uint256",
      },
    ],
    name: "borrowFor",
    outputs: [
      {
        internalType: "uint256",
        name: "debtAmount",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "debtShare",
        type: "uint256",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_asset",
        type: "address",
      },
      {
        internalType: "address",
        name: "_borrower",
        type: "address",
      },
    ],
    name: "borrowPossible",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_asset",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "_amount",
        type: "uint256",
      },
      {
        internalType: "bool",
        name: "_collateralOnly",
        type: "bool",
      },
    ],
    name: "deposit",
    outputs: [
      {
        internalType: "uint256",
        name: "collateralAmount",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "collateralShare",
        type: "uint256",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_asset",
        type: "address",
      },
      {
        internalType: "address",
        name: "_depositor",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "_amount",
        type: "uint256",
      },
      {
        internalType: "bool",
        name: "_collateralOnly",
        type: "bool",
      },
    ],
    name: "depositFor",
    outputs: [
      {
        internalType: "uint256",
        name: "collateralAmount",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "collateralShare",
        type: "uint256",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_asset",
        type: "address",
      },
      {
        internalType: "address",
        name: "_depositor",
        type: "address",
      },
    ],
    name: "depositPossible",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address[]",
        name: "_users",
        type: "address[]",
      },
      {
        internalType: "bytes",
        name: "_flashReceiverData",
        type: "bytes",
      },
    ],
    name: "flashLiquidate",
    outputs: [
      {
        internalType: "address[]",
        name: "assets",
        type: "address[]",
      },
      {
        internalType: "uint256[][]",
        name: "receivedCollaterals",
        type: "uint256[][]",
      },
      {
        internalType: "uint256[][]",
        name: "shareAmountsToRepay",
        type: "uint256[][]",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "getAssets",
    outputs: [
      {
        internalType: "address[]",
        name: "assets",
        type: "address[]",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "getAssetsWithState",
    outputs: [
      {
        internalType: "address[]",
        name: "assets",
        type: "address[]",
      },
      {
        components: [
          {
            internalType: "contract IShareToken",
            name: "collateralToken",
            type: "address",
          },
          {
            internalType: "contract IShareToken",
            name: "collateralOnlyToken",
            type: "address",
          },
          {
            internalType: "contract IShareToken",
            name: "debtToken",
            type: "address",
          },
          {
            internalType: "uint256",
            name: "totalDeposits",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "collateralOnlyDeposits",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "totalBorrowAmount",
            type: "uint256",
          },
        ],
        internalType: "struct IBaseSilo.AssetStorage[]",
        name: "assetsStorage",
        type: "tuple[]",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "harvestProtocolFees",
    outputs: [
      {
        internalType: "uint256[]",
        name: "harvestedAmounts",
        type: "uint256[]",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "initAssetsTokens",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_asset",
        type: "address",
      },
    ],
    name: "interestData",
    outputs: [
      {
        components: [
          {
            internalType: "uint256",
            name: "harvestedProtocolFees",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "protocolFees",
            type: "uint256",
          },
          {
            internalType: "uint64",
            name: "interestRateTimestamp",
            type: "uint64",
          },
          {
            internalType: "enum IBaseSilo.AssetStatus",
            name: "status",
            type: "uint8",
          },
        ],
        internalType: "struct IBaseSilo.AssetInterestData",
        name: "",
        type: "tuple",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_user",
        type: "address",
      },
    ],
    name: "isSolvent",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_asset",
        type: "address",
      },
    ],
    name: "liquidity",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_asset",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "_amount",
        type: "uint256",
      },
    ],
    name: "repay",
    outputs: [
      {
        internalType: "uint256",
        name: "repaidAmount",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "repaidShare",
        type: "uint256",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_asset",
        type: "address",
      },
      {
        internalType: "address",
        name: "_borrower",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "_amount",
        type: "uint256",
      },
    ],
    name: "repayFor",
    outputs: [
      {
        internalType: "uint256",
        name: "repaidAmount",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "repaidShare",
        type: "uint256",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "siloAsset",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "siloRepository",
    outputs: [
      {
        internalType: "contract ISiloRepository",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "syncBridgeAssets",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_asset",
        type: "address",
      },
    ],
    name: "utilizationData",
    outputs: [
      {
        components: [
          {
            internalType: "uint256",
            name: "totalDeposits",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "totalBorrowAmount",
            type: "uint256",
          },
          {
            internalType: "uint64",
            name: "interestRateTimestamp",
            type: "uint64",
          },
        ],
        internalType: "struct IBaseSilo.UtilizationData",
        name: "data",
        type: "tuple",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_asset",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "_amount",
        type: "uint256",
      },
      {
        internalType: "bool",
        name: "_collateralOnly",
        type: "bool",
      },
    ],
    name: "withdraw",
    outputs: [
      {
        internalType: "uint256",
        name: "withdrawnAmount",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "withdrawnShare",
        type: "uint256",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_asset",
        type: "address",
      },
      {
        internalType: "address",
        name: "_depositor",
        type: "address",
      },
      {
        internalType: "address",
        name: "_receiver",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "_amount",
        type: "uint256",
      },
      {
        internalType: "bool",
        name: "_collateralOnly",
        type: "bool",
      },
    ],
    name: "withdrawFor",
    outputs: [
      {
        internalType: "uint256",
        name: "withdrawnAmount",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "withdrawnShare",
        type: "uint256",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
];

const _bytecode =
  "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";

type SiloConvexConstructorParams =
  | [signer?: Signer]
  | ConstructorParameters<typeof ContractFactory>;

const isSuperArgs = (
  xs: SiloConvexConstructorParams
): xs is ConstructorParameters<typeof ContractFactory> => xs.length > 1;

export class SiloConvex__factory extends ContractFactory {
  constructor(...args: SiloConvexConstructorParams) {
    if (isSuperArgs(args)) {
      super(...args);
    } else {
      super(_abi, _bytecode, args[0]);
    }
    this.contractName = "SiloConvex";
  }

  deploy(
    _repository: string,
    _stateChangesHandler: string,
    _siloAsset: string,
    _version: BigNumberish,
    overrides?: Overrides & { from?: string | Promise<string> }
  ): Promise<SiloConvex> {
    return super.deploy(
      _repository,
      _stateChangesHandler,
      _siloAsset,
      _version,
      overrides || {}
    ) as Promise<SiloConvex>;
  }
  getDeployTransaction(
    _repository: string,
    _stateChangesHandler: string,
    _siloAsset: string,
    _version: BigNumberish,
    overrides?: Overrides & { from?: string | Promise<string> }
  ): TransactionRequest {
    return super.getDeployTransaction(
      _repository,
      _stateChangesHandler,
      _siloAsset,
      _version,
      overrides || {}
    );
  }
  attach(address: string): SiloConvex {
    return super.attach(address) as SiloConvex;
  }
  connect(signer: Signer): SiloConvex__factory {
    return super.connect(signer) as SiloConvex__factory;
  }
  static readonly contractName: "SiloConvex";
  public readonly contractName: "SiloConvex";
  static readonly bytecode = _bytecode;
  static readonly abi = _abi;
  static createInterface(): SiloConvexInterface {
    return new utils.Interface(_abi) as SiloConvexInterface;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): SiloConvex {
    return new Contract(address, _abi, signerOrProvider) as SiloConvex;
  }
}
